import React, { useState } from 'react'
import useAnalysis from 'hooks/useAnalysis'
import { Status } from 'enums'

import Header from 'components/Header'
import Top from 'pages/Top'
import routes from 'routes'

const App = () => {
  const [isOpened, setIsOpened] = useState(false)
  const { status, questionIndex, resultIndex } = useAnalysis()

  const $trigger = document.querySelector('#js-app-trigger')
  $trigger?.addEventListener('click', () => setIsOpened(true))

  const $btmNav = document.querySelector<HTMLElement>('.sp_fnav')

  // * ===== ステートの検証用 =====
  // const { status, questionNumber, questionIndex, resultIndex, answerHistory } =
  //   useAnalysis()
  // console.log(`Status: ${status}`)
  // console.log(`Question number: ${questionNumber}`)
  // console.log(`Question index: ${questionIndex}`)
  // console.log(`Answer history: ${JSON.stringify(answerHistory, null, '\t')}`)
  // console.log(`Result index: ${resultIndex}`)

  if (isOpened) {
    const addStatus = () => {
      switch (status) {
        case Status.NOT_YET:
          return 'is--not-yet'

        case Status.IN_PROGRESS:
          return 'is--in-progress'

        case Status.DONE:
          return 'is--done'

        default:
          return ''
      }
    }

    if ($btmNav) {
      $btmNav.style.display = 'none'
    }

    return (
      <div className={`app ${addStatus()}`}>
        <div className="app__wrapper">
          <Header setIsOpened={setIsOpened} />
          <div className="app__view">
            {(() => {
              switch (status) {
                case Status.NOT_YET:
                  return <Top />

                case Status.IN_PROGRESS:
                  return routes.questions[questionIndex]

                case Status.DONE:
                  return routes.results[resultIndex]

                default:
                  return null
              }
            })()}
          </div>
        </div>
      </div>
    )
  } else {
    if ($btmNav) {
      $btmNav.style.display = ''
    }

    return null
  }
}

export default App
